module.exports = __webpack_public_path__ + "static/media/plum_logo_white.3e26c6ef.png";